import service from 'Api/service';
// SerializedProducts

export default {
  showOne: (product, serialNumber) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/products/${product.id}/serialized_products/${serialNumber}`
    );
  },
  showBySerialNumber: (product, serialNumber) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/products/${product.id}/serialized_products/${serialNumber}/show_by_serial_number`
    );
  },
  fetchSerializedProductInformationBetweenLocations: (
    originLocationId,
    targetLocationId,
    serialNumber
  ) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/serialized_products/${serialNumber}/fetch_serialized_product_information_between_locations?origin_location_id=${originLocationId}&target_location_id=${targetLocationId}`
    );
  },
  moveMultipleSerializedInventory: (data) => {
    return service.patch(
      import.meta.env.VITE_API_DOMAIN +
        `/api/products/serialized_products/move_multiple_serialized_inventory`,
      data
    );
  },
  fetchSerializedProductsForCheckOut: (product, rentalToken) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/products/${product.id}/serialized_products/available_to_check_out`,
      {
        rental_token: rentalToken,
      }
    );
  },
  fetchSerializedProductsFromLink: (link) => {
    return service.get(import.meta.env.VITE_API_DOMAIN + link);
  },
  fetchSerializedProductsForCheckIn: (product, rentalToken) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/products/${product.id}/serialized_products/available_to_check_in`,
      {
        rental_token: rentalToken,
      }
    );
  },
  updateUsageUnit: (product, serialNumber, updatedUsageUnit) => {
    return service.patch(
      import.meta.env.VITE_API_DOMAIN +
        `/api/products/${product.id}/serialized_products/${serialNumber}/update_usages`,
      updatedUsageUnit
    );
  },
  scanOneCheckIn: (pick_list_item, serialNumber) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/pick_list_items/${pick_list_item.id}/serialized_products/${serialNumber}/scan_check_in`
    );
  },
  printAll: (inventoryId, endPointType) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/${endPointType}/${inventoryId}/serialized_products/print`
    );
  },
  generateSerializedProducts: (
    inventoryId,
    endPointType,
    selectedProducts = []
  ) => {
    return service.post(
      import.meta.env.VITE_API_DOMAIN +
        `/api/${endPointType}/${inventoryId}/serialized_products/generate_serialized_products`,
      {
        serialized_products_ids: selectedProducts,
      }
    );
  },
  printOne: (inventoryId, endPointType, serialNumber) => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/${endPointType}/${inventoryId}/serialized_products/${serialNumber}/print_single`
    );
  },
  itemInfo: (rentalToken, serialNumber, type) =>
    service.get(
      import.meta.env.VITE_API_DOMAIN +
        `/api/rentals/${rentalToken}/search_by_serial_number`,
      {
        serial_number: serialNumber,
        type: type,
      }
    ),
};
